import React, { FunctionComponent } from 'react';
import AssociatedAccounts from './associated-accounts/AssociatedAccounts';
import DeviceDetails from './device-details/DeviceDetails';
import ErrorCodes from './error-codes/ErrorCodes';
import Footer from '../Footer';
import Repairs from './repairs/Repairs';

const Device: FunctionComponent = () => (
    <>
        <DeviceDetails />
        <AssociatedAccounts />
        <Repairs />
        <ErrorCodes />
        <Footer />
    </>
);

export default Device;
